import { render, staticRenderFns } from "./CallMessage.vue?vue&type=template&id=6bed38db&scoped=true&"
import script from "./CallMessage.vue?vue&type=script&lang=js&"
export * from "./CallMessage.vue?vue&type=script&lang=js&"
import style0 from "./CallMessage.vue?vue&type=style&index=0&id=6bed38db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bed38db",
  null
  
)

export default component.exports